import {useEffect, useState} from "react";
import {ButtonNav} from "./AccountManagementRolePage"
import {useSearchParams} from "react-router-dom";
import {AccountManagementDeleteUser} from "../../../components/account/admin/AccountManagementDeleteUser";
import AccountLayout from "../../../components/layouts/AccountLayout.tsx";

export const AccountManagementAdminPanelPage = () => {
    const [selectedView, setSelectedView] = useState<"DELETE_USER" | null>(null);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const view = searchParams.get('view') as "DELETE_USER" | null;
        if (view === "DELETE_USER" || view === null) {
            setSelectedView(view);
        } else {
            setSelectedView(null);
        }
    }, [searchParams])

    return (
        <AccountLayout>
            {selectedView === null && (
                <>
                    {ButtonNav("Usuń użytkownika", "Trwale usuń użytkownika", () => {
                        setSearchParams({view: "DELETE_USER"})
                    })}
                </>
            )}
            {selectedView === 'DELETE_USER' && (
                <AccountManagementDeleteUser/>
            )}
        </AccountLayout>
    )
}
